import EventBus from "@plugins/common/service/eventbus";
export const AnchoringEventBus = new EventBus();
